// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file plataforma_costos.proto (package sextante.plataforma.costos.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file plataforma_costos.proto.
 */
export const file_plataforma_costos: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Sin parametros.
 *
 * @generated from message sextante.plataforma.costos.v1.ListTarifasRequest
 */
export type ListTarifasRequest = Message<"sextante.plataforma.costos.v1.ListTarifasRequest"> & {
};

/**
 * Describes the message sextante.plataforma.costos.v1.ListTarifasRequest.
 * Use `create(ListTarifasRequestSchema)` to create a new message.
 */
export const ListTarifasRequestSchema: GenMessage<ListTarifasRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_costos, 0);

/**
 * Tarifa sobre la que se actua.
 *
 * @generated from message sextante.plataforma.costos.v1.TarifaIdRequest
 */
export type TarifaIdRequest = Message<"sextante.plataforma.costos.v1.TarifaIdRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message sextante.plataforma.costos.v1.TarifaIdRequest.
 * Use `create(TarifaIdRequestSchema)` to create a new message.
 */
export const TarifaIdRequestSchema: GenMessage<TarifaIdRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_costos, 1);

/**
 * Sin datos: que el rpc no falle ya indica que se hizo.
 *
 * @generated from message sextante.plataforma.costos.v1.TarifaAccionResponse
 */
export type TarifaAccionResponse = Message<"sextante.plataforma.costos.v1.TarifaAccionResponse"> & {
};

/**
 * Describes the message sextante.plataforma.costos.v1.TarifaAccionResponse.
 * Use `create(TarifaAccionResponseSchema)` to create a new message.
 */
export const TarifaAccionResponseSchema: GenMessage<TarifaAccionResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_costos, 2);

/**
 * Tramo de DATA AG. Precio ausente = negociacion directa.
 *
 * @generated from message sextante.plataforma.costos.v1.TarifaDataAgItem
 */
export type TarifaDataAgItem = Message<"sextante.plataforma.costos.v1.TarifaDataAgItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Texto del tramo que se muestra.
   *
   * @generated from field: string rango = 2;
   */
  rango: string;

  /**
   * Hectareas maximas del tramo. Ausente = sin tope.
   *
   * @generated from field: optional int32 tope_maximo_ha = 3;
   */
  topeMaximoHa?: number | undefined;

  /**
   * Precio por anio, en pesos. Ausente = negociacion directa.
   *
   * @generated from field: optional int64 precio_anual = 4;
   */
  precioAnual?: bigint | undefined;

  /**
   * Posicion del tramo en la lista.
   *
   * @generated from field: int32 orden = 5;
   */
  orden: number;
};

/**
 * Describes the message sextante.plataforma.costos.v1.TarifaDataAgItem.
 * Use `create(TarifaDataAgItemSchema)` to create a new message.
 */
export const TarifaDataAgItemSchema: GenMessage<TarifaDataAgItem> = /*@__PURE__*/
  messageDesc(file_plataforma_costos, 3);

/**
 * Tramos de DATA AG, por orden.
 *
 * @generated from message sextante.plataforma.costos.v1.ListTarifasDataAgResponse
 */
export type ListTarifasDataAgResponse = Message<"sextante.plataforma.costos.v1.ListTarifasDataAgResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.costos.v1.TarifaDataAgItem items = 1;
   */
  items: TarifaDataAgItem[];
};

/**
 * Describes the message sextante.plataforma.costos.v1.ListTarifasDataAgResponse.
 * Use `create(ListTarifasDataAgResponseSchema)` to create a new message.
 */
export const ListTarifasDataAgResponseSchema: GenMessage<ListTarifasDataAgResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_costos, 4);

/**
 * Tramo de DATA AG a crear o editar.
 *
 * @generated from message sextante.plataforma.costos.v1.GuardarTarifaDataAgRequest
 */
export type GuardarTarifaDataAgRequest = Message<"sextante.plataforma.costos.v1.GuardarTarifaDataAgRequest"> & {
  /**
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * @generated from field: string rango = 2;
   */
  rango: string;

  /**
   * @generated from field: optional int32 tope_maximo_ha = 3;
   */
  topeMaximoHa?: number | undefined;

  /**
   * @generated from field: optional int64 precio_anual = 4;
   */
  precioAnual?: bigint | undefined;

  /**
   * @generated from field: int32 orden = 5;
   */
  orden: number;
};

/**
 * Describes the message sextante.plataforma.costos.v1.GuardarTarifaDataAgRequest.
 * Use `create(GuardarTarifaDataAgRequestSchema)` to create a new message.
 */
export const GuardarTarifaDataAgRequestSchema: GenMessage<GuardarTarifaDataAgRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_costos, 5);

/**
 * Cultivo incluido en una categoria de PROTEC.
 *
 * @generated from message sextante.plataforma.costos.v1.CultivoAspersionItem
 */
export type CultivoAspersionItem = Message<"sextante.plataforma.costos.v1.CultivoAspersionItem"> & {
  /**
   * @generated from field: string cultivo_id = 1;
   */
  cultivoId: string;

  /**
   * @generated from field: string nombre = 2;
   */
  nombre: string;
};

/**
 * Describes the message sextante.plataforma.costos.v1.CultivoAspersionItem.
 * Use `create(CultivoAspersionItemSchema)` to create a new message.
 */
export const CultivoAspersionItemSchema: GenMessage<CultivoAspersionItem> = /*@__PURE__*/
  messageDesc(file_plataforma_costos, 6);

/**
 * Categoria de PROTEC, con su precio por hectarea y sus cultivos.
 *
 * @generated from message sextante.plataforma.costos.v1.TarifaAspersionItem
 */
export type TarifaAspersionItem = Message<"sextante.plataforma.costos.v1.TarifaAspersionItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string categoria = 2;
   */
  categoria: string;

  /**
   * Precio por hectarea, en pesos.
   *
   * @generated from field: int64 precio_por_ha = 3;
   */
  precioPorHa: bigint;

  /**
   * @generated from field: int32 orden = 4;
   */
  orden: number;

  /**
   * @generated from field: repeated sextante.plataforma.costos.v1.CultivoAspersionItem cultivos = 5;
   */
  cultivos: CultivoAspersionItem[];
};

/**
 * Describes the message sextante.plataforma.costos.v1.TarifaAspersionItem.
 * Use `create(TarifaAspersionItemSchema)` to create a new message.
 */
export const TarifaAspersionItemSchema: GenMessage<TarifaAspersionItem> = /*@__PURE__*/
  messageDesc(file_plataforma_costos, 7);

/**
 * Categorias de PROTEC, por orden.
 *
 * @generated from message sextante.plataforma.costos.v1.ListTarifasAspersionResponse
 */
export type ListTarifasAspersionResponse = Message<"sextante.plataforma.costos.v1.ListTarifasAspersionResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.costos.v1.TarifaAspersionItem items = 1;
   */
  items: TarifaAspersionItem[];
};

/**
 * Describes the message sextante.plataforma.costos.v1.ListTarifasAspersionResponse.
 * Use `create(ListTarifasAspersionResponseSchema)` to create a new message.
 */
export const ListTarifasAspersionResponseSchema: GenMessage<ListTarifasAspersionResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_costos, 8);

/**
 * Categoria de PROTEC a crear o editar.
 *
 * @generated from message sextante.plataforma.costos.v1.GuardarTarifaAspersionRequest
 */
export type GuardarTarifaAspersionRequest = Message<"sextante.plataforma.costos.v1.GuardarTarifaAspersionRequest"> & {
  /**
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * @generated from field: string categoria = 2;
   */
  categoria: string;

  /**
   * @generated from field: int64 precio_por_ha = 3;
   */
  precioPorHa: bigint;

  /**
   * @generated from field: int32 orden = 4;
   */
  orden: number;

  /**
   * @generated from field: repeated string cultivo_ids = 5;
   */
  cultivoIds: string[];
};

/**
 * Describes the message sextante.plataforma.costos.v1.GuardarTarifaAspersionRequest.
 * Use `create(GuardarTarifaAspersionRequestSchema)` to create a new message.
 */
export const GuardarTarifaAspersionRequestSchema: GenMessage<GuardarTarifaAspersionRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_costos, 9);

/**
 * Equipo que se vende o alquila, como RASTRO o bascula.
 *
 * @generated from message sextante.plataforma.costos.v1.TarifaEquipoItem
 */
export type TarifaEquipoItem = Message<"sextante.plataforma.costos.v1.TarifaEquipoItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string nombre = 2;
   */
  nombre: string;

  /**
   * Unidad de venta.
   *
   * @generated from field: string unidad = 3;
   */
  unidad: string;

  /**
   * Precio por unidad, en pesos.
   *
   * @generated from field: int64 precio = 4;
   */
  precio: bigint;

  /**
   * @generated from field: optional string nota = 5;
   */
  nota?: string | undefined;

  /**
   * @generated from field: int32 orden = 6;
   */
  orden: number;
};

/**
 * Describes the message sextante.plataforma.costos.v1.TarifaEquipoItem.
 * Use `create(TarifaEquipoItemSchema)` to create a new message.
 */
export const TarifaEquipoItemSchema: GenMessage<TarifaEquipoItem> = /*@__PURE__*/
  messageDesc(file_plataforma_costos, 10);

/**
 * Equipos, por orden.
 *
 * @generated from message sextante.plataforma.costos.v1.ListTarifasEquipoResponse
 */
export type ListTarifasEquipoResponse = Message<"sextante.plataforma.costos.v1.ListTarifasEquipoResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.costos.v1.TarifaEquipoItem items = 1;
   */
  items: TarifaEquipoItem[];
};

/**
 * Describes the message sextante.plataforma.costos.v1.ListTarifasEquipoResponse.
 * Use `create(ListTarifasEquipoResponseSchema)` to create a new message.
 */
export const ListTarifasEquipoResponseSchema: GenMessage<ListTarifasEquipoResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_costos, 11);

/**
 * Equipo a crear o editar.
 *
 * @generated from message sextante.plataforma.costos.v1.GuardarTarifaEquipoRequest
 */
export type GuardarTarifaEquipoRequest = Message<"sextante.plataforma.costos.v1.GuardarTarifaEquipoRequest"> & {
  /**
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * @generated from field: string nombre = 2;
   */
  nombre: string;

  /**
   * @generated from field: string unidad = 3;
   */
  unidad: string;

  /**
   * @generated from field: int64 precio = 4;
   */
  precio: bigint;

  /**
   * @generated from field: optional string nota = 5;
   */
  nota?: string | undefined;

  /**
   * @generated from field: int32 orden = 6;
   */
  orden: number;
};

/**
 * Describes the message sextante.plataforma.costos.v1.GuardarTarifaEquipoRequest.
 * Use `create(GuardarTarifaEquipoRequestSchema)` to create a new message.
 */
export const GuardarTarifaEquipoRequestSchema: GenMessage<GuardarTarifaEquipoRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_costos, 12);

/**
 * Variable de precio de VISTA, el servicio de fotogrametria.
 *
 * @generated from message sextante.plataforma.costos.v1.TarifaFotogrametriaItem
 */
export type TarifaFotogrametriaItem = Message<"sextante.plataforma.costos.v1.TarifaFotogrametriaItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string variable = 2;
   */
  variable: string;

  /**
   * @generated from field: string descripcion = 3;
   */
  descripcion: string;

  /**
   * @generated from field: int64 valor = 4;
   */
  valor: bigint;

  /**
   * @generated from field: int32 orden = 5;
   */
  orden: number;
};

/**
 * Describes the message sextante.plataforma.costos.v1.TarifaFotogrametriaItem.
 * Use `create(TarifaFotogrametriaItemSchema)` to create a new message.
 */
export const TarifaFotogrametriaItemSchema: GenMessage<TarifaFotogrametriaItem> = /*@__PURE__*/
  messageDesc(file_plataforma_costos, 13);

/**
 * Variables de VISTA, por orden.
 *
 * @generated from message sextante.plataforma.costos.v1.ListTarifasFotogrametriaResponse
 */
export type ListTarifasFotogrametriaResponse = Message<"sextante.plataforma.costos.v1.ListTarifasFotogrametriaResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.costos.v1.TarifaFotogrametriaItem items = 1;
   */
  items: TarifaFotogrametriaItem[];
};

/**
 * Describes the message sextante.plataforma.costos.v1.ListTarifasFotogrametriaResponse.
 * Use `create(ListTarifasFotogrametriaResponseSchema)` to create a new message.
 */
export const ListTarifasFotogrametriaResponseSchema: GenMessage<ListTarifasFotogrametriaResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_costos, 14);

/**
 * Valor nuevo de una variable de VISTA.
 *
 * @generated from message sextante.plataforma.costos.v1.GuardarTarifaFotogrametriaRequest
 */
export type GuardarTarifaFotogrametriaRequest = Message<"sextante.plataforma.costos.v1.GuardarTarifaFotogrametriaRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int64 valor = 2;
   */
  valor: bigint;
};

/**
 * Describes the message sextante.plataforma.costos.v1.GuardarTarifaFotogrametriaRequest.
 * Use `create(GuardarTarifaFotogrametriaRequestSchema)` to create a new message.
 */
export const GuardarTarifaFotogrametriaRequestSchema: GenMessage<GuardarTarifaFotogrametriaRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_costos, 15);

/**
 * Tarifas de la app Plataforma (menu Precios; Pipeline las lee para cotizar). Migracion a gRPC-Web con
 * logica propia (ver CLAUDE.md). Listas sin eliminados, por orden. Requiere sesion de Plataforma.
 *
 * @generated from service sextante.plataforma.costos.v1.CostosPlataformaService
 */
export const CostosPlataformaService: GenService<{
  /**
   * Tramos de DATA AG por hectareas (agricultura / ganaderia).
   *
   * @generated from rpc sextante.plataforma.costos.v1.CostosPlataformaService.ListAgricultura
   */
  listAgricultura: {
    methodKind: "unary";
    input: typeof ListTarifasRequestSchema;
    output: typeof ListTarifasDataAgResponseSchema;
  },
  /**
   * Crea un tramo de DATA AG agricultura si no viene id, o lo edita si viene.
   *
   * @generated from rpc sextante.plataforma.costos.v1.CostosPlataformaService.GuardarAgricultura
   */
  guardarAgricultura: {
    methodKind: "unary";
    input: typeof GuardarTarifaDataAgRequestSchema;
    output: typeof TarifaDataAgItemSchema;
  },
  /**
   * Baja logica de un tramo de DATA AG agricultura. NotFound si no existe.
   *
   * @generated from rpc sextante.plataforma.costos.v1.CostosPlataformaService.EliminarAgricultura
   */
  eliminarAgricultura: {
    methodKind: "unary";
    input: typeof TarifaIdRequestSchema;
    output: typeof TarifaAccionResponseSchema;
  },
  /**
   * Tramos de DATA AG ganaderia, por orden.
   *
   * @generated from rpc sextante.plataforma.costos.v1.CostosPlataformaService.ListGanaderia
   */
  listGanaderia: {
    methodKind: "unary";
    input: typeof ListTarifasRequestSchema;
    output: typeof ListTarifasDataAgResponseSchema;
  },
  /**
   * Crea un tramo de DATA AG ganaderia si no viene id, o lo edita si viene.
   *
   * @generated from rpc sextante.plataforma.costos.v1.CostosPlataformaService.GuardarGanaderia
   */
  guardarGanaderia: {
    methodKind: "unary";
    input: typeof GuardarTarifaDataAgRequestSchema;
    output: typeof TarifaDataAgItemSchema;
  },
  /**
   * Baja logica de un tramo de DATA AG ganaderia. NotFound si no existe.
   *
   * @generated from rpc sextante.plataforma.costos.v1.CostosPlataformaService.EliminarGanaderia
   */
  eliminarGanaderia: {
    methodKind: "unary";
    input: typeof TarifaIdRequestSchema;
    output: typeof TarifaAccionResponseSchema;
  },
  /**
   * Categorias de PROTEC (aspersion) con sus cultivos.
   *
   * @generated from rpc sextante.plataforma.costos.v1.CostosPlataformaService.ListAspersion
   */
  listAspersion: {
    methodKind: "unary";
    input: typeof ListTarifasRequestSchema;
    output: typeof ListTarifasAspersionResponseSchema;
  },
  /**
   * Crea una categoria de PROTEC si no viene id, o la edita si viene, con sus cultivos. Los cultivos no se
   * pueden repetir.
   *
   * @generated from rpc sextante.plataforma.costos.v1.CostosPlataformaService.GuardarAspersion
   */
  guardarAspersion: {
    methodKind: "unary";
    input: typeof GuardarTarifaAspersionRequestSchema;
    output: typeof TarifaAspersionItemSchema;
  },
  /**
   * Baja logica de la categoria y de sus cultivos. NotFound si no existe.
   *
   * @generated from rpc sextante.plataforma.costos.v1.CostosPlataformaService.EliminarAspersion
   */
  eliminarAspersion: {
    methodKind: "unary";
    input: typeof TarifaIdRequestSchema;
    output: typeof TarifaAccionResponseSchema;
  },
  /**
   * Equipos (RASTRO, bascula...): el precio vive en la tabla de costos.
   *
   * @generated from rpc sextante.plataforma.costos.v1.CostosPlataformaService.ListEquipos
   */
  listEquipos: {
    methodKind: "unary";
    input: typeof ListTarifasRequestSchema;
    output: typeof ListTarifasEquipoResponseSchema;
  },
  /**
   * Crea un equipo con su registro de costo si no viene id, o lo edita si viene.
   *
   * @generated from rpc sextante.plataforma.costos.v1.CostosPlataformaService.GuardarEquipo
   */
  guardarEquipo: {
    methodKind: "unary";
    input: typeof GuardarTarifaEquipoRequestSchema;
    output: typeof TarifaEquipoItemSchema;
  },
  /**
   * Baja logica del equipo y de su registro de costo. NotFound si no existe.
   *
   * @generated from rpc sextante.plataforma.costos.v1.CostosPlataformaService.EliminarEquipo
   */
  eliminarEquipo: {
    methodKind: "unary";
    input: typeof TarifaIdRequestSchema;
    output: typeof TarifaAccionResponseSchema;
  },
  /**
   * Variables de VISTA (fotogrametria): solo se edita el valor.
   *
   * @generated from rpc sextante.plataforma.costos.v1.CostosPlataformaService.ListFotogrametria
   */
  listFotogrametria: {
    methodKind: "unary";
    input: typeof ListTarifasRequestSchema;
    output: typeof ListTarifasFotogrametriaResponseSchema;
  },
  /**
   * Cambia el valor de una variable de VISTA. Las variables no se crean ni se borran.
   *
   * @generated from rpc sextante.plataforma.costos.v1.CostosPlataformaService.GuardarFotogrametria
   */
  guardarFotogrametria: {
    methodKind: "unary";
    input: typeof GuardarTarifaFotogrametriaRequestSchema;
    output: typeof TarifaFotogrametriaItemSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_plataforma_costos, 0);

